import { Component, Directive, Input } from '@angular/core';
import { IconLibraryTypes } from '@liberty-financial/ng-components/lib/components/icon/library.enum';
import { EnumUtil } from '@shared/utilities/enum/enum.util';
import { Guid } from 'guid-typescript';
import { InlineMessageAppearance, InlineMessageAppearanceET, InlineMessageIcons } from '../inline-message-button/inline-message-button.enum';

@Directive({
  selector: 'app-inline-message-content'
})
export class InlineMessageContent {
}

@Component({
  selector: 'app-inline-message',
  templateUrl: './inline-message.component.html',
  styleUrls: ['./inline-message.component.scss']
})
export class InlineMessageComponent {
  // inputs
  @Input()
  identifier: string = 'inline-message-list-' + Guid.create().toString();

  @Input()
  headline: string | null = null;

  @Input()
  appearance: InlineMessageAppearanceET = InlineMessageAppearance.Default;

  @Input()
  icon: IconLibraryTypes | undefined = undefined;
  
  constructor() { }

  public get showHeadline(): boolean {
    return !!this.headline;
  }

  public get determineIcon(): IconLibraryTypes | undefined {
    if (this.icon) {
      return this.icon;
    }

    const enumKey = EnumUtil.getEnumKeyByValue(InlineMessageAppearance, this.appearance);

    if (!enumKey) {
      return;
    }

    return InlineMessageIcons[enumKey];
  }
}
